import type MarkdownIt from "markdown-it/lib";
import type { RuleBlock } from "markdown-it/lib/parser_block";
import type { RuleCore } from "markdown-it/lib/parser_core";

export const LIST_OPEN_TYPES = ["bullet_list_open", "ordered_list_open"];
export const LIST_ITEM_OPEN = "list_item_open";

const detectTaskList: RuleCore = (state) => {
	const tokens = state.tokens;
	if (!tokens?.length) return;

	const Token = state.Token;

	for (let i = 0; i < tokens.length; i++) {
		const t = tokens[i];
		if (!t) continue;

		if (t.type === LIST_ITEM_OPEN) {
			const next = tokens[i + 1];
			if (next && LIST_OPEN_TYPES.includes(next.type)) {
				const paraOpen = new Token("paragraph_open", "p", 1);
				const inline = new Token("inline", "", 0);
				inline.content = "";
				inline.children = [];
				const paraClose = new Token("paragraph_close", "p", -1);

				if (t.map) {
					paraOpen.map = [t.map[0], t.map[0]];
					inline.map = paraOpen.map;
				}

				tokens.splice(i + 1, 0, paraOpen, inline, paraClose);

				i += 3;
			}
		}
	}

	return true;
};

const ORDERED_ITEM_MARKER = /^\d{1,9}[.)](?:[ \t]|$)/;

// CommonMark lets only a list starting at 1 interrupt a paragraph. Inside a list item a marker at the item's
// content indent is its sublist whatever the number: files written before the blank line was added hold it so.
const sublistInterruptsItemText: RuleBlock = (state, startLine, _endLine, silent) => {
	if (!silent || state.parentType !== "paragraph" || state.listIndent < 0) return false;
	const indent = state.sCount[startLine] - state.blkIndent;
	if (indent < 0 || indent >= 4) return false;
	const line = state.src.slice(state.bMarks[startLine] + state.tShift[startLine], state.eMarks[startLine]);
	return ORDERED_ITEM_MARKER.test(line);
};

const listPlugin = (md: MarkdownIt) => {
	md.block.ruler.before("list", "sublist-interrupts-item-text", sublistInterruptsItemText, { alt: ["paragraph"] });
	md.core.ruler.after("cleanup-task-list-inline", "nested-list-sanitizer", detectTaskList);
};

export default listPlugin;
